import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import updeep from 'updeep';
import { FUNNEL_ROUTE } from '@src/Routes/links';
import { createLink } from '@src/util/createLink';
import { idify } from '@src/util/idify';
import { getRecruiter } from '@src/redux/selectors/recruiter';
import apolloClient from '@src/graphql/apollo';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { checkSubscriptionState } from '@src/redux/actions/subscription';
import { checkOpeningLimit } from '@src/redux/actions/opening';
import { SaveOpeningDocument, PublishOpeningDocument, RecommendedUsersSortOptionEnum } from '@src/graphql/generated';
import { trackEvent } from '@src/metrics';
import { ActiveView } from '@src/views/Opening/enums/activeView.enum';
import View from './View';

@connect(
  state => ({
    recruiter: getRecruiter(state),
  }),
  {
    checkOpeningLimit,
    checkSubscriptionState,
    push,
    setErrorFlashMessage,
  },
)
export default class FunnelReview extends PureComponent {
  static propTypes = {
    benefits: PropTypes.arrayOf(PropTypes.object.isRequired),
    checkOpeningLimit: PropTypes.func.isRequired,
    checkSubscriptionState: PropTypes.func.isRequired,
    company: PropTypes.object,
    opening: PropTypes.object,
    push: PropTypes.func.isRequired,
    recruiter: PropTypes.object,
    setErrorFlashMessage: PropTypes.func.isRequired,
  };

  state = {
    opening: this.props.opening,
    publishing: false,
  };

  saveOpeningPaidAddons(paidAddons) {
    apolloClient.mutate({
      mutation: SaveOpeningDocument,
      variables: {
        openingId: this.props.opening.id,
        openingInput: {
          openingPaidAddons: paidAddons.map(addon => ({
            isRecurring: addon.isRecurring,
            priceInEur: addon.discountedPriceInEur ?? addon.priceInEur ?? 0,
            type: addon.type,
          })),
        },
      },
    });
  }

  publish = async () => {
    const { push, setErrorFlashMessage } = this.props;
    const { opening } = this.state;
    const openingId = idify(opening);

    this.setState({ publishing: true });

    try {
      await apolloClient.mutate({
        mutation: PublishOpeningDocument,
        variables: { openingId: idify(opening) },
      });

      push(
        createLink({
          link: FUNNEL_ROUTE,
          params: { openingId },
          queryParams: {
            activeView: ActiveView.INVITE_CANDIDATES,
            recommendedUsersSortOption: RecommendedUsersSortOptionEnum.RELEVANCE,
          },
        }),
      );
    } catch (_) {
      this.setState({ publishing: false });
      setErrorFlashMessage();
    }

    trackEvent({
      context: MetricContext.CREATE_OPENING,
      interaction: MetricAction.OPENING_PUBLISHED,
      payload: { 'Opening Id': openingId },
    });
  };

  changeField = (path, value) => {
    const updatePath = path === 'openingPaidAddons' ? 'opening.paidAddons' : `opening.${path}`;

    this.setState(updeep.updateIn(updatePath, value), () => {
      if (path === 'openingPaidAddons') {
        this.saveOpeningPaidAddons(value);
      } else {
        apolloClient.mutate({
          mutation: SaveOpeningDocument,
          variables: {
            openingId: this.state.opening.id,
            openingInput: { [path]: value },
          },
        });
      }
    });
  };

  render() {
    const { opening, publishing } = this.state;
    const { recruiter, checkSubscriptionState, company, checkOpeningLimit, benefits } = this.props;

    if (!opening || !company?.profile) {
      return null;
    }

    return (
      <View
        benefits={benefits}
        changeField={this.changeField}
        checkOpeningLimit={checkOpeningLimit}
        checkSubscriptionState={checkSubscriptionState}
        companyProfile={company.profile}
        opening={opening}
        publish={this.publish}
        publishing={publishing}
        recruiter={recruiter}
      />
    );
  }
}
